// SeriesZone — German. Two words are deliberately NOT repeated here because MarketPage (the
// only page that mounts this zone) already registers them with the same value: 'All' and
// 'nothing has answered yet'. Series labels and dimension tokens ('vd.aje.places', 'contributor')
// are NOT here either — they render through `seriesLabel`/`dimLabel` in `series.v1.ts`, three
// languages, like raster labels, never through this catalogue.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Series': 'Reihen',
  'Public statistics about the market, not about one organisation — the file, the row and the date behind every figure':
    'Öffentliche Statistik über den Markt, nicht über eine Organisation — Datei, Zeile und Datum hinter jeder Zahl',

  // the presets
  'RI beneficiaries': 'RI-Beziehende',
  'Non-take-up': 'Nichtinanspruchnahme',
  'Childcare': 'Kinderbetreuung',
  'Child protection': 'Kinderschutz',

  // the filter band
  'Source': 'Quelle',
  'Also from': 'Auch von',

  // the grid
  'canton': 'Kanton',
  'Dimension': 'Dimension',
  'Geography': 'Geografie',
  'Show the file this figure was read from': 'Zeigt die Datei, aus der diese Zahl gelesen wurde',
  'was {value} in the file of {date}': 'war {value} in der Datei vom {date}',

  // the empty and error states
  'The series store did not answer: {error}': 'Der Reihenspeicher hat nicht geantwortet: {error}',
  'No point has landed for this series yet — the parser that fills it has not run, or has found nothing to file.':
    'Für diese Reihe liegt noch kein Punkt vor — der Parser, der sie füllt, ist noch nicht gelaufen oder hat nichts gefunden.',
  'No series behind this preset has been built yet — a later wave of the sources programme fills it.':
    'Für diese Vorauswahl ist noch keine Reihe aufgebaut — eine spätere Welle des Quellenprogramms füllt sie.',
  'Pick a series to read its figures.': 'Eine Reihe wählen, um ihre Zahlen zu lesen.',
}, 'SeriesZone');
